// place
export const OSAKA_JAPAN = "Osaka, Japan";
